import { Controller } from "@hotwired/stimulus"

// The invite box on a card in the round. "Cancel" closes it, clears what was
// typed, and brings the "Invite <name>" button back.
//
// The page refreshes by morphing whenever a reply lands. An open box keeps
// its text through that, but only while the new page still has a box for
// this card. Once the card is invited the new page has none, and the morph
// removes it. A box marked data-turbo-permanent cannot do that: a morph never
// removes a permanent element, so it outlived the pick it was for.
export default class extends Controller {
  static targets = ["text"]

  connect() {
    this.keep = this.keep.bind(this)
    this.element.addEventListener("turbo:before-morph-element", this.keep)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-element", this.keep)
  }

  // Turbo asks before it morphs, and asks with no new element before it
  // removes. Hold the box as it is only when it is open and still wanted.
  keep(event) {
    if (event.target !== this.element) return
    if (this.element.open && event.detail.newElement) event.preventDefault()
  }

  cancel(event) {
    event.preventDefault()
    if (this.hasTextTarget) this.textTarget.value = ""
    this.element.open = false
  }
}
